<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item" >
         <div class="text-center">
           <p v-if="user" class="text-uppercase text-dark font-weight-bold mb-0">{{user.name}}</p>
           <p v-if="user" class="text-lowercase text-sm">{{user.email}}</p>
         </div>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','agent_ftd','agent_retention'])">
        <sidenav-collapse navText="Inicio" :to="{ name: 'dashboard' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan('administrator')">
        <sidenav-collapse navText="Agentes" :to="{ name: 'users' }">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>
      <!-- <li class="nav-item">
        <sidenav-collapse navText="Transacciones" :to="{ name: 'transactions' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse navText="Comisiones" :to="{ name: 'commissions' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li> -->
      <li class="nav-item" v-if="$userCan(['agent_ftd', 'agent_retention','supervisor_ftd','supervisor_retention','administrator'])">
        <sidenav-collapse navText="Leads Logs" :to="{ name: 'logs' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','supervisor_ftd','supervisor_retention'])">
        <sidenav-collapse navText="Leads" :to="{ name: 'leads' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator', 'agent_ftd','supervisor_ftd'])">
        <sidenav-collapse :navText="$userCan(['administrator','supervisor_ftd'])?'Leads FTD':'Leads'" :to="{ name: 'leads-ftd' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator', 'agent_retention','supervisor_ftd', 'supervisor_retention'])">
        <sidenav-collapse :navText="$userCan(['administrator', 'agent_retention','supervisor_ftd', 'supervisor_retention'])?'Leads Retención':'Leads'" :to="{ name: 'leads-retention' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','supervisor_ftd','supervisor_retention','agent_retention'])">
        <sidenav-collapse navText="SMS" :to="{ name: 'sms' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator'])">
        <sidenav-collapse navText="Configuración" :to="{ name: 'config' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <div class="sidenav-footer">
    <a
      class="btn bg-gradient-dark mt-4 w-100 mb-0"
      @click="openPasswordModal"
      type="button"
      >Cambiar contraseña</a
    >
    <a
      class="btn bg-gradient-success mt-2 w-100"
      @click="logout"
      type="button"
      >Cerrar sesión</a
    >
  </div>

  <!-- Modal: cambiar contraseña del usuario de la sesión (admin/agente/supervisor) -->
  <div v-if="showPasswordModal">
    <div class="modal fade show" style="display: block" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cambiar contraseña</h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Cerrar"
              @click="closePasswordModal"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="pwdError" class="alert alert-danger py-2 text-sm">
              {{ pwdError }}
            </div>
            <div v-if="pwdSuccess" class="alert alert-success py-2 text-sm">
              Contraseña actualizada correctamente.
            </div>
            <div class="mb-3">
              <label class="form-label">Contraseña actual</label>
              <input
                v-model="pwd.current"
                type="password"
                class="form-control"
                autocomplete="current-password"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Nueva contraseña</label>
              <input
                v-model="pwd.new"
                type="password"
                class="form-control"
                autocomplete="new-password"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Confirmar nueva contraseña</label>
              <input
                v-model="pwd.confirm"
                type="password"
                class="form-control"
                autocomplete="new-password"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closePasswordModal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn bg-gradient-success"
              :disabled="pwdLoading"
              @click="submitPassword"
            >
              {{ pwdLoading ? "Guardando..." : "Guardar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Shop from "../../components/Icon/Shop.vue";
import Office from "../../components/Icon/Office.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";
import {decrypt} from "@/utils/encrypt";
import routerList from "@/router/index"
import {get, post} from "@/utils/httpRequest";
export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data : () => ({
    title: "Pagos",
    controls: "",
    isActive: "active",
    arrayOptions: [
        {key:'dashboard', name: ''},
      'users','transactions','leads', 'clients'],
    arrayMenu: [],
    user_id: null,
    user: null,
    showPasswordModal: false,
    pwdLoading: false,
    pwdError: "",
    pwdSuccess: false,
    pwd: { current: "", new: "", confirm: "" },
  }),
  components: {
    SidenavCollapse,
    Shop,
    Office,
    CreditCard,
  },
  mounted() {
    this.getMenu()
    this.user_id = localStorage.getItem('payment-admin-uuid')
    setTimeout(()=>{
      this.getProfile()
    },500)
  },
  methods: {
    getMenu(){
      const storage = localStorage.getItem('payment-admin-type')
      setTimeout(()=>{
        const rol = decrypt(storage)
        const router = routerList.options.routes;
        this.arrayOptions.forEach(el => {
          router.forEach(item=> {
            if(item.name === el){
              if(item.meta.roles.includes(rol)){
                this.arrayMenu.push(el)
              }
            }
          })
        })
      },500)
    },
    async getProfile(){
      const {data} = await get(`users/find-one?id=${this.user_id}`, null)
      data.password = ''
      this.user = data
    },
    logout() {
      localStorage.clear()
      this.$router.push('/')
    },
    openPasswordModal() {
      this.pwd = { current: "", new: "", confirm: "" };
      this.pwdError = "";
      this.pwdSuccess = false;
      this.pwdLoading = false;
      this.showPasswordModal = true;
    },
    closePasswordModal() {
      this.showPasswordModal = false;
    },
    async submitPassword() {
      this.pwdError = "";
      this.pwdSuccess = false;
      if (!this.pwd.current || !this.pwd.new || !this.pwd.confirm) {
        this.pwdError = "Completa todos los campos.";
        return;
      }
      if (this.pwd.new.length < 6) {
        this.pwdError = "La nueva contraseña debe tener al menos 6 caracteres.";
        return;
      }
      if (this.pwd.new !== this.pwd.confirm) {
        this.pwdError = "Las contraseñas no coinciden.";
        return;
      }
      this.pwdLoading = true;
      try {
        // Reusa el endpoint self-service: cambia la contraseña del usuario del
        // JWT (sea admin/agente/supervisor) tras validar la actual.
        await post("users/change-password", {
          current: this.pwd.current,
          new: this.pwd.new,
        });
        this.pwdSuccess = true;
        this.pwd = { current: "", new: "", confirm: "" };
        setTimeout(() => {
          this.showPasswordModal = false;
        }, 1500);
      } catch (e) {
        this.pwdError =
          (e && e.response && e.response.data && e.response.data.message) ||
          "No se pudo cambiar la contraseña. Verificá la contraseña actual.";
      } finally {
        this.pwdLoading = false;
      }
    },
  },
};
</script>
